import React, { useEffect, useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import * as Yup from "yup";
import Select from '../../library/ReactSelect';
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import {
    getResourceDetailsCancelToken,
    issuedResource,
    registrationStudentSearchListCancelToken
} from "../../../services/StudentService";
import { FORM_DATE_FORMAT } from "../../../utils/Constants";
import PermissionsGate from "../../../utils/permissionGate";

const MissingResource = ({ setResourceName }) => {

    const history = useHistory();
    const { id } = useParams()

    const [language, setLanguage] = useState([]);
    const [issueTo, setIssueTo] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [basicInfo, setBasicInfo] = useState({});
    const [infoData, setInfoData] = useState({});

    const CommonDropdownData = useSelector(state => state.registerDropdownValues && Object.keys(state.registerDropdownValues).length ?
        state.registerDropdownValues : {});

    function setDropdownData() {
        if (Object.keys(CommonDropdownData).length) {           
            if (CommonDropdownData.language) {
                setLanguage(CommonDropdownData?.language)
            }
        }
    }

    usePermissionGuardRedirect(['sresourcemedit']);

    useEffect(() => {
        const dropdownSource = axios.CancelToken.source();
        
        const fetchData = async () => {
            try {
            const resp = await registrationStudentSearchListCancelToken({type:"dropdown"},dropdownSource.token);
            let respData = resp?.data?.data
            setIssueTo([...respData])
            } catch (error) {
            if (!axios.isCancel(error)) {
                console.error(error);
            }
            }
        };
        
        fetchData();
        
        return () => {
            dropdownSource.cancel('Component unmounted');
        };
    }, []);

    useEffect(() => {
        const cancelTokenSources = [];
    
        const getResourceData = async () => {
          setDropdownData();
      
          cancelTokenSources.forEach(source => {
            source.cancel('New request made');
          });
      
          const source = axios.CancelToken.source();
          cancelTokenSources.push(source);
      
          try {
            const res = await getResourceDetailsCancelToken(id, source.token);
            setBasicInfo(res.data?.resourceDetails)
            setResourceName(res.data?.resourceDetails?.title)
            if (res.data?.ResourceInformationDetails) {
                setInfoData(res.data?.ResourceInformationDetails)

            }
          } catch (error) {
            if (!axios.isCancel(error)) {
              console.error(error);
            }
          }
        };
      
        getResourceData();
    
        return () => {
          cancelTokenSources.forEach(source => {
            source.cancel('Component unmounted');
          });
        };
    }, []);

    // useEffect(() => {
    //     setDropdownData()
    //     registrationStudentSearchList({type:"dropdown"}).then((resp) => {
    //         let respData = resp?.data?.data
    //         // let tempIssueTo = [];
    //         // issueTo.map((issue) => {
    //         //     tempIssueTo.push({ value: issue.id, label: issue.first_name + " " + issue.last_name })
    //         // })
    //         setIssueTo([...respData])
    //     });

    //     getResourceDetails(id)
    //         .then((res) => {
    //             setBasicInfo(res.data?.resourceDetails)
    //             setResourceName(res.data?.resourceDetails?.title)
    //             if (res.data?.ResourceInformationDetails) {
    //                 setInfoData(res.data?.ResourceInformationDetails)

    //             }
    //         })
    //         .catch((err) => { console.log(err); });
    // }, [])

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: basicInfo?.title || "",
            reported_date: "",
            misplaced_by: infoData?.misplaced_by || "",
            comments: "",
            language: basicInfo?.language || ""
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Title is required"),
            reported_date: Yup.string().required("Date Reported is required"),
            misplaced_by: Yup.string().required("Misplaced By is required"),
        }),
        onSubmit: (values) => {
            setIsDisabled(true)
            let date = values.reported_date

            if (values.reported_date) {
                values.reported_date = new Date(date).getTime().toString() / 1000;
            }
            values = { ...values }
            let body;
            body = {
                resource_id: id,
                status: "missing",
                id: infoData.id,
                reported_date:values.reported_date,
                misplaced_by:values.misplaced_by,
                comment:values.comments,
                language:values.language
            }

            issuedResource(body)
                .then((res) => {
                    setIsDisabled(false)
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Updated successfully",
                        willClose: goToListing
                    });
                })
                .catch((err) => {
                    setIsDisabled(false)
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: `${err?.response?.data?.data}`,
                    });
                });
        },
    });

    const goToListing = () => {
        history.push(`/support/student-hub-library/resource-management/table`)
    }

    return (
        <div className="card card-new card-profile-info-card">
            <div className="card-header">Mark as missing</div>
            <div className="card-body-inr card-body-info">
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Title*</label>
                                <div className="form-icon-group mb-4">
                                    <input type="text" className={"form-control" + (formik.errors.title && formik.touched.title ? " is-invalid" : "")} name="title" placeholder="Title" title="Title" value={formik.values.title} onChange={formik.handleChange} onBlur={formik.handleBlur} readOnly />
                                    {formik.errors.title && formik.touched.title ? (
                                        <span className="exclamation">
                                            <i className="fal fa-exclamation-circle"></i>
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group" >
                                <label>Misplaced By*</label>
                                <div className="form-icon-group mb-4">
                                    <div className="form-control custom-select-box">
                                        <Select
                                            className={"form-control custom-select-box" + (formik.errors.misplaced_by && formik.touched.misplaced_by ? " is-invalid" : "")}
                                            name="misplaced_by"
                                            value={issueTo?.filter(val => val.value.toString() === formik.values.misplaced_by.toString())}
                                            onChange={(value) => {
                                                if (value) {
                                                    formik.setFieldValue("misplaced_by", value.value);
                                                } else {
                                                    formik.setFieldValue("misplaced_by", "");
                                                }
                                            }}
                                            placeholder={formik.values.misplaced_by ? formik.values.misplaced_by : "Select..."}
                                            onBlur={formik.handleBlur}
                                            options={issueTo}
                                            maxMenuHeight={175}
                                            isClearable
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Date Reported*</label>
                                <DatePicker
                                    autoComplete="off"
                                    selected={formik.values.reported_date}
                                    onChange={(date) => {
                                        formik.setFieldValue("reported_date", date);
                                    }}
                                    name="date"
                                    dateFormat={FORM_DATE_FORMAT}
                                    showYearDropdown
                                    scrollableYearDropdown
                                    dateFormatCalendar="MMMM"
                                    className={
                                        "form-control cursor-pointer" +
                                        (formik.errors.reported_date &&
                                            formik.touched.reported_date
                                            ? " is-invalid"
                                            : "")
                                    }
                                    title="Date Reported"
                                    placeholderText="Date Reported"
                                    timeIntervals={15}
                                    onChangeRaw={(e) => {
                                        e.preventDefault();
                                    }}
                                    minDate={new Date()}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Comments</label>
                                <div className="form-icon-group mb-4">
                                    <input
                                        type="text"
                                        className={"form-control" + (formik.errors.comments && formik.touched.comments ? " is-invalid" : "")}
                                        name="comments"
                                        placeholder="Comments"
                                        title="Comments"
                                        value={formik.values.comments}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group" >
                                <label>Language</label>
                                <div className="form-icon-group mb-4">
                                    <div className="form-control custom-select-box">
                                        <Select className={"form-control custom-select-box" + (formik.errors.language && formik.touched.language ? " is-invalid" : "")}
                                            name="language"
                                            value={language?.filter(val => val.value === formik.values.language)}
                                            onChange={(value) => {
                                                if (value) {
                                                    formik.setFieldValue("language", value.value);
                                                } else {
                                                    formik.setFieldValue("language", "");
                                                }
                                            }}
                                            placeholder={formik.values.language ? formik.values.language : "Select..."}
                                            onBlur={formik.handleBlur}
                                            options={language}
                                            maxMenuHeight={175}
                                            isClearable
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group-save-cancel ">
                        <PermissionsGate errorProps={{ disabled: true }} scopes={["shedit"]}>
                            <button className="btn btn-save btn-success" type="button" onClick={formik.handleSubmit} title="Save" >
                                {isDisabled === false ? <i className="fal fa-save"></i> : <i class="fas fa-cog fa-spin"></i>}
                                Save
                            </button>
                        </PermissionsGate>
                        <button className="btn btn-close btn-danger" type="button" title="Cancel" onClick={() => history.goBack()} >
                            <i className="fal fa-times"></i>
                            Cancel
                        </button>
                    </div>
                    <div className="form-group form-group-save-cancel">
                        {Object.keys(formik.values).map(key => {
                            return formik.touched[key] && formik.errors[key] ? (
                                <div className="invalid-feedback d-block">
                                    {formik.errors[key]}
                                </div>
                            ) : ""
                        })}
                    </div>
                </form>
            </div>

        </div>
    );
};

export default MissingResource;
